import * as z from 'zod/mini';

export const CustomerTravelplansRequestSchema = z.object({
  page: z.nullish(z.number()),
  per_page: z.nullish(z.number()),
  search: z.nullish(z.string()),
  locale: z.string(),
  office_id: z.number(),
  department_id: z.number(),
});

const CustomerTravelplanSchema = z.object({
  id: z.union([z.number(), z.string()]),
  name: z.string(),
  start_date: z.nullish(z.string()),
  end_date: z.nullish(z.string()),
  pax: z.number(),
  status: z.string(),
});

export const CustomerTravelplansResponseSchema = z.object({
  data: z.array(CustomerTravelplanSchema),
  current_page: z.number(),
  per_page: z.number(),
  total: z.number(),
});
